export enum DocumentStatus {
    SubeTuDocumento = 1,
    EnRevision = 2,
    Aprobado = 3,
    Rechazado = 4,
    VerificacionHumana = 5,
    RevisionManual = 8,
    AprobadoPendiente = 9
}

// You can also add a helper object for human-readable labels if needed
export const DocumentStatusLabels: Record<DocumentStatus, string> = {
    [DocumentStatus.SubeTuDocumento]: 'Sube tu documento',
    [DocumentStatus.EnRevision]: 'En revisión',
    [DocumentStatus.Aprobado]: 'Aprobado',
    [DocumentStatus.Rechazado]: 'Rechazado',
    [DocumentStatus.VerificacionHumana]: 'Verificación Humana',
    [DocumentStatus.RevisionManual]: 'Revisión Manual',
    [DocumentStatus.AprobadoPendiente]: 'Aprobado'
}
